module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M29.933 0H1.996C.892 0 0 .99 0 2.091v21.951c0 1.104.892 1.9 1.996 1.9h7.156l5.402 5.45c.389.391.9.609 1.411.609s1.022-.231 1.411-.621l5.402-5.438h7.156c1.104 0 1.995-.796 1.995-1.9V2.091C31.929.989 31.037 0 29.934 0zm-5.987 16.962a.998.998 0 0 1-.998.998H8.979a.998.998 0 0 1-.998-.998v-1.995c0-.551.447-.998.998-.998h13.969c.551 0 .998.447.998.998v1.995zm0-5.987a.998.998 0 0 1-.998.998H8.979a.998.998 0 0 1-.998-.998V8.98c0-.551.447-.998.998-.998h13.969c.551 0 .998.447.998.998v1.995z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/post-comment-1.js
// module id = 1352
// module chunks = 14